import { PaymentMethod } from "@phonero/common-graphql/types"
import { RouteComponentProps } from "react-router-dom"
import { Pick3 } from "ts-multipick"
import PaymentCallbackPage from "./PaymentCallbackPage"

const PaymentCallbackVippsRecurring = ({
  match: {
    params: { paymentID },
  },
}: {} & Pick3<
  RouteComponentProps<{ paymentID?: string }>,
  "match",
  "params",
  "paymentID"
>) => {
  return PaymentCallbackPage({
    paymentID,
    paymentMethod: PaymentMethod.Vippsrecurring,
  })
}

export default PaymentCallbackVippsRecurring
